











































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';
import LayoutContent from '@/components/LayoutContent.vue';
import Toggle from '@/components/Toggle.vue';
import SearchField from '@/components/SearchField.vue';
import Select from '@/components/Select.vue';
import Loader from '@/components/Loader.vue';
import api from '@/libs/api';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import Button from '@/components/Button.vue';
import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import Cell from '@/components/Table/Cell.vue';
import Pagination from '@/components/Pagination.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';

interface UserDetail {
  label: string;
  email: string;
  name: string;
  layer: number;
  role: string;
}

@Component({
  components: {
    LayoutContent,
    ValidationObserver,
    Toggle,
    SearchField,
    Select,
    Loader,
    Button,
    Table,
    TableBody,
    Row,
    Header,
    Cell,
    Pagination,
    StatusIndicator,
  },
})

export default class BusinessDetail extends Vue {
  loading = false;
  loadingSubmit = false;
  statusApproval = false;
  totalLayer = 0;
  selectedTotalLayer: { label: string; value: number } | null = null;
  optionApprovalLayer: any[] = [];
  avalableUser = false;
  dataMultiLayer = { user: [] };
  optionUser: any[] = [];
  mapPicLayer: any[] = [];
  optionUserCustom: {
    checker: UserDetail[];
    approver: UserDetail[];
  } = {
    checker: [],
    approver: [],
  };

  dataMultiLog = [];

  optionUser2: any[] = [];

  page = 1;
  totalPage = 1;
  from = 0;
  to = 0;
  totalItem = 0;

  get isFormValid() {
    return this.dataMultiLayer.user.every((userList: UserDetail[]) => userList.length > 0);
  }

  async created() {
    await this.getApprovalUser();
    await this.getLog();
  }

  @Watch('selectedTotalLayer')
  onTotalLayerChange() {
    const total = this.selectedTotalLayer?.value || 0;
    this.mapPicLayer = Array.from({ length: total });
    this.populateLayerDefaults();
  }

  @Watch('dataMultiLayer')
  onTotalLayerChangeData() {
    this.populateLayerDefaults();
  }

  async getLog() {
    this.loading = true;
    try {
      const { data } = await api.get('/disbursement/approval/multi/log', {
        // eslint-disable-next-line @typescript-eslint/camelcase
        params: { merchant_code: this.$route.params.code },
      });
      this.dataMultiLog = data.data;
      // console.log(this.dataMultiLog);
    } catch (err) {
      console.error(err);
    } finally {
      this.loading = false;
    }
  }

  // async isFormDisabled() {
  //   return this.dataMultiLog && this.dataMultiLog.length > 0;
  // }

  async getApprovalUser() {
    this.loading = true;
    try {
      const { data } = await api.get('/disbursement/approval/multi/user', {
        // eslint-disable-next-line @typescript-eslint/camelcase
        params: { merchant_code: this.$route.params.code },
      });

      if (data) {
        this.statusApproval = data.total_layer && data.total_layer.status === 'ACTIVE';
        this.totalLayer = data.total_layer?.total_layer || 0;
        if (this.totalLayer === 0) {
          this.selectedTotalLayer = null;
        } else {
          this.selectedTotalLayer = {
            label: `${this.totalLayer} Layer`,
            value: this.totalLayer,
          };
        }

        this.optionUser = data.all_user.map((user: any) => ({
          label: user.email,
          email: user.email,
          name: user.name,
          layer: user.layer,
          role: user.role,
        }));

        data.all_user.forEach((user: any) => {
          const userDetail: UserDetail = {
            label: user.email,
            email: user.email,
            name: user.name,
            layer: user.layer,
            role: user.role,
          };

          if (user.role === 'Checker Disbursement') {
            this.optionUserCustom.checker.push(userDetail);
          } else if (user.role === 'Approval Disbursement') {
            this.optionUserCustom.approver.push(userDetail);
          }
        });

        // eslint-disable-next-line max-len
        this.optionApprovalLayer = Array.from({ length: Math.min(this.optionUserCustom.checker.length, 10) }, (_, i) => {
          const value = i + 2;
          return { label: `${value} Layer`, value };
        });

        this.avalableUser = this.optionUserCustom.checker.length > 0 && this.optionUserCustom.approver.length > 0;

        this.optionUser2 = data.user_set_up.map((user: any) => ({
          label: user.email,
          email: user.email,
          name: user.name,
          layer: user.layer,
          role: user.role,
        }));
      }
    } catch (err) {
      console.error(err);
    } finally {
      this.loading = false;
    }
  }

  getAvailableCheckerOptions() {
    // Get the list of users from 'checker' role for all layers
    const usedCheckers = this.dataMultiLayer.user.flat().map((user: UserDetail) => user.email);

    // Filter out the already selected users in other layers
    return this.optionUserCustom.checker.filter((user: UserDetail) => !usedCheckers.includes(user.email));
  }

  populateLayerDefaults() {
    const groupedUsers = this.optionUser2.reduce((acc, user) => {
      if (user.layer !== null) {
        if (!acc[user.layer]) acc[user.layer] = { checkers: [], approvers: [] };
        if (user.role === 'Approval Disbursement') {
          acc[user.layer].approvers.push(user);
        } else {
          acc[user.layer].checkers.push(user);
        }
      }
      return acc;
    }, {});

    const totalLayers = this.selectedTotalLayer?.value || 0;
    this.mapPicLayer.forEach((_, index) => {
      const layer = index + 1;
      if (layer === totalLayers) {
        const approvers = groupedUsers[layer]?.approvers || [];
        this.$set(this.dataMultiLayer.user, index, approvers);
      } else {
        const checkers = groupedUsers[layer]?.checkers || [];
        this.$set(this.dataMultiLayer.user, index, checkers);
      }
    });
  }

  async submitData() {
    this.loadingSubmit = true;
    const total = this.selectedTotalLayer?.value || 0;
    try {
      const payload = {
        status: this.statusApproval,
        // eslint-disable-next-line @typescript-eslint/camelcase
        merchant_code: this.$route.params.code,
        // eslint-disable-next-line @typescript-eslint/camelcase
        total_layer: this.selectedTotalLayer?.value,
        // eslint-disable-next-line @typescript-eslint/camelcase
        user_map: this.dataMultiLayer.user
          .map((userList: UserDetail[], index: number) => {
            if (index >= total) return [];
            return userList.map((user: UserDetail) => ({
              email: user.email,
              layer: index + 1,
            }));
          })
          .flat(),
      };

      const { data } = await api.post('/disbursement/approval/multi/user', payload);
      showToast(ToastType.SUCCESS, 'Success', data.message);
    } catch (err) {
      showToast(ToastType.FAILED, 'Failed', (err as any).response.data.error.errors.map((e: any) => e.message));
    } finally {
      this.loadingSubmit = false;
      this.optionUserCustom.checker = [];
      this.optionUserCustom.approver = [];
      this.getApprovalUser();
    }
  }
}
